import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import fr from './fr'

Vue.use(VueI18n)

const navigatorLanguage = window.navigator.language.split('-')[0]

export default new VueI18n({
  locale: navigatorLanguage,
  messages: {
    fr,
    en
  }
})
